import * as React from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Dialog as DialogStacked, DialogContent as DialogContentStacked } from "@/components/ui/dialog-stacked";
import { ModalHeader } from "@/components/ui/modal-header";
import { ModalHeaderStacked } from "@/components/ui/modal-header-stacked";
import { cn } from "@/lib/utils";

interface UnifiedModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  icon: React.ReactNode;
  title: React.ReactNode;
  description?: string;
  descriptionClassName?: string;
  variant?: "gradient" | "destructive";
  stacked?: boolean;
  contentClassName?: string;
  headerClassName?: string;
  children: React.ReactNode;
}

export function UnifiedModal({
  open,
  onOpenChange,
  icon,
  title,
  description,
  descriptionClassName,
  variant,
  stacked = false,
  contentClassName,
  headerClassName,
  children,
}: UnifiedModalProps) {
  const ModalRoot = stacked ? DialogStacked : Dialog;
  const ModalContent = stacked ? DialogContentStacked : DialogContent;
  const ModalHeaderComponent = stacked ? ModalHeaderStacked : ModalHeader;

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalContent className={cn("max-w-[90vw] sm:max-w-md", contentClassName)}>
        <ModalHeaderComponent
          icon={icon}
          title={title}
          description={description}
          descriptionClassName={descriptionClassName}
          variant={variant}
          className={headerClassName}
        />
        {children}
      </ModalContent>
    </ModalRoot>
  );
}

